module.exports = __webpack_public_path__ + "img/pending_customer.f6dbccbd.png";